export const coeffs = {
    c_1:299792458,  // Speed of light in meters per second
    // c_2:983571056, // Speed of light in feet per second
    c_2:186282.397, // Speed of light in miles per second
}